// Injected at build time from package.json (see the start/build scripts).
// Bump package.json "version" on each release, together with admin/frontend.
export const APP_VERSION = process.env.REACT_APP_VERSION || 'dev';
